import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import React from 'react';
import { cx } from '@elliemae/ds-utilities/utils';
import DSButton from '@elliemae/ds-basic/Button';
import { aggregatedClasses } from '@elliemae/ds-classnames';

var _IntentIconColors;
var Intents = {
  SUCCESS: 'success',
  INFO: 'info',
  DANGER: 'danger',
  WARNING: 'warning'
};
var IntentIconColors = (_IntentIconColors = {}, _defineProperty(_IntentIconColors, Intents.SUCCESS, ['success', 900]), _defineProperty(_IntentIconColors, Intents.INFO, ['brand-primary', 600]), _defineProperty(_IntentIconColors, Intents.DANGER, ['danger', 900]), _defineProperty(_IntentIconColors, Intents.WARNING, ['warning', 500]), _IntentIconColors);
var ValueWrapper = aggregatedClasses('span')('icon-column-cell');

var addColorToIcon = function addColorToIcon(icon, intentColor) {
  if (icon.props.color) {
    return icon;
  }

  return /*#__PURE__*/React.cloneElement(icon, {
    color: intentColor
  });
};

function createColumn(_ref) {
  var property = _ref.property,
      label = _ref.label,
      headerIcon = _ref.headerIcon,
      _ref$getRowIcon = _ref.getRowIcon,
      getRowIcon = _ref$getRowIcon === void 0 ? function () {
    return null;
  } : _ref$getRowIcon,
      _ref$isVisited = _ref.isVisited,
      isVisited = _ref$isVisited === void 0 ? function () {
    return null;
  } : _ref$isVisited,
      _ref$intent = _ref.intent,
      intent = _ref$intent === void 0 ? Intents.SUCCESS : _ref$intent,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 60 : _ref$width,
      onClick = _ref.onClick,
      visible = _ref.visible,
      resizable = _ref.resizable,
      sortable = _ref.sortable,
      searchable = _ref.searchable;

  var formatter = function formatter(value, extraParams) {
    var icon = getRowIcon(value, extraParams);

    var onClickHandler = function onClickHandler(e) {
      return onClick(e, extraParams);
    };

    return /*#__PURE__*/React.createElement(ValueWrapper, {
      className: cx("icc-".concat(intent), isVisited(value, extraParams))
    }, icon && addColorToIcon(icon, IntentIconColors[intent]), onClick && typeof value !== 'undefined' ? /*#__PURE__*/React.createElement(DSButton, {
      buttonType: "text",
      intent: intent,
      labelText: value,
      onClick: onClickHandler
    }) : value);
  };

  return {
    property: property,
    label: label,
    headerStyle: {
      justifyContent: 'center'
    },
    header: {
      formatters: [function () {
        return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.cloneElement(headerIcon, {
          color: IntentIconColors[intent]
        }));
      }]
    },
    cell: {
      formatters: [formatter]
    },
    cellStyle: {
      justifyContent: 'center'
    },
    width: width,
    visible: typeof visible === 'undefined' || visible,
    resizable: resizable,
    sortable: sortable,
    searchable: searchable
  };
}

export default createColumn;
//# sourceMappingURL=IconColumn.js.map
